import { render } from "./CompetenceComponent.vue?vue&type=template&id=64f2f709&scoped=true&ts=true"
import script from "./CompetenceComponent.vue?vue&type=script&lang=ts"
export * from "./CompetenceComponent.vue?vue&type=script&lang=ts"

import "./CompetenceComponent.vue?vue&type=style&index=0&id=64f2f709&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f2f709"]])

export default __exports__